const css = `.app-invitation-header {
  display: flex;
  align-items: center;
  gap: 8px;
}
.app-invitation-header .pi {
  font-size: var(--font-size-base);
}
.app-invitation-header strong {
  margin-right: 4px;
}
.app-invitation .app-invitation-header {
  display: flex;
  align-items: center;
  gap: 8px;
}
.app-invitation .app-invitation-header strong {
  margin: 0;
}
.app-invitation .app-invitation-header .app-invitation-status.success {
  color: var(--success);
}
.app-invitation .app-invitation-header .app-invitation-status.error {
  color: var(--danger);
}
.app-invitation .app-invitation-header button {
  padding: 0;
}
.app-invitation .app-invitation-header button .p-button-label {
  font-size: var(--font-size-sm);
}

.copy-invitation-link-button {
  margin-top: 8px;
}

.invitation-dialog .p-dialog-content {
  overflow: visible;
}
.invitation-dialog .dialog-message {
  margin-bottom: 16px;
}
.invitation-dialog form {
  margin-bottom: 16px;
}
.invitation-dialog .dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL29wdC9yZW5kZXIvcHJvamVjdC9zcmMvc3JjL2NvbXBvbmVudHMvVXNlclByb2ZpbGVBcHBJbnZpdGF0aW9uIiwic291cmNlcyI6WyJVc2VyUHJvZmlsZUFwcEludml0YXRpb24uc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDRTtFQUNFO0VBQ0E7RUFDQTs7QUFFQTtFQUNFOztBQUdGO0VBQ0U7O0FBSUo7RUFDRTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTs7QUFJQTtFQUNFOztBQUVGO0VBQ0U7O0FBSUo7RUFDRTs7QUFDQTtFQUNFOzs7QUFNUjtFQUNFOzs7QUFJQTtFQUNFOztBQUVGO0VBQ0U7O0FBR0Y7RUFDRTs7QUFHRjtFQUNFO0VBQ0E7RUFDQSIsInNvdXJjZXNDb250ZW50IjpbIi5hcHAtaW52aXRhdGlvbiB7XG4gICYtaGVhZGVyIHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAgZ2FwOiA4cHg7XG5cbiAgICAucGkge1xuICAgICAgZm9udC1zaXplOiB2YXIoLS1mb250LXNpemUtYmFzZSk7XG4gICAgfVxuXG4gICAgc3Ryb25nIHtcbiAgICAgIG1hcmdpbi1yaWdodDogNHB4O1xuICAgIH1cbiAgfVxuXG4gIC5hcHAtaW52aXRhdGlvbi1oZWFkZXIge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICBnYXA6IDhweDtcblxuICAgIHN0cm9uZyB7XG4gICAgICBtYXJnaW46IDA7XG4gICAgfVxuXG4gICAgLmFwcC1pbnZpdGF0aW9uLXN0YXR1cyB7XG4gICAgICAmLnN1Y2Nlc3Mge1xuICAgICAgICBjb2xvcjogdmFyKC0tc3VjY2Vzcyk7XG4gICAgICB9XG4gICAgICAmLmVycm9yIHtcbiAgICAgICAgY29sb3I6IHZhcigtLWRhbmdlcik7XG4gICAgICB9XG4gICAgfVxuXG4gICAgYnV0dG9uIHtcbiAgICAgIHBhZGRpbmc6IDA7XG4gICAgICAucC1idXR0b24tbGFiZWwge1xuICAgICAgICBmb250LXNpemU6IHZhcigtLWZvbnQtc2l6ZS1zbSk7XG4gICAgICB9XG4gICAgfVxuICB9XG59XG5cbi5jb3B5LWludml0YXRpb24tbGluay1idXR0b24ge1xuICBtYXJnaW4tdG9wOiA4cHg7XG59XG5cbi5pbnZpdGF0aW9uLWRpYWxvZyB7XG4gIC5wLWRpYWxvZy1jb250ZW50IHtcbiAgICBvdmVyZmxvdzogdmlzaWJsZTtcbiAgfVxuICAuZGlhbG9nLW1lc3NhZ2Uge1xuICAgIG1hcmdpbi1ib3R0b206IDE2cHg7XG4gIH1cblxuICBmb3JtIHtcbiAgICBtYXJnaW4tYm90dG9tOiAxNnB4O1xuICB9XG5cbiAgLmRpYWxvZy1mb290ZXIge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAganVzdGlmeS1jb250ZW50OiBmbGV4LWVuZDtcbiAgICBnYXA6IDhweDtcbiAgfVxufVxuIl19 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
